import { axiosWithAuth } from "helpers";

export const searchService = {
	search,
	getApplications,
	getBoardings,
	getUnderwritings,
	getUsers,
	getAgents,
	getMerchants,
	getAgentOffices,
	getTerminals,
	getPends,
	getTidEquipments,
	getInstallations,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 50;

function search({ pattern, page }) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/search`,
		data: {
			pattern,
			page,
		},
	};

	return axiosWithAuth(options);
}

function getApplications({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
			sort_type: 1,
		},
		url: `${API_URL}/api/applications`,
	};

	return axiosWithAuth(options);
}

function getBoardings({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
			sort_type: 1,
		},
		url: `${API_URL}/api/applications/boarding`,
	};

	return axiosWithAuth(options);
}

function getUnderwritings({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
			sort_type: 1,
		},
		url: `${API_URL}/api/underwriting`,
	};

	return axiosWithAuth(options);
}

function getMerchants({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
		},
		url: `${API_URL}/api/merchants`,
	};

	return axiosWithAuth(options);
}

function getUsers({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
		},
		url: `${API_URL}/api/users`,
	};

	return axiosWithAuth(options);
}

function getAgents({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
		},
		url: `${API_URL}/api/agents`,
	};

	return axiosWithAuth(options);
}

function getAgentOffices({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
		},
		url: `${API_URL}/api/companies`,
	};

	return axiosWithAuth(options);
}

function getTerminals({ pattern, page }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			search_for: pattern,
		},
		url: `${API_URL}/api/global_search/terminals`,
	};

	return axiosWithAuth(options);
}

function getPends({ pattern, page }) {
	const params = {
		page_index: page,
		page_size: PAGE_SIZE,
		search_for: pattern,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/pends/list`,
	};

	return axiosWithAuth(options);
}

function getTidEquipments({ pattern, page }) {
	const params = {
		page_index: page,
		page_size: PAGE_SIZE,
		search_for: pattern,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/applications/equipment_queue`,
	};

	return axiosWithAuth(options);
}

function getInstallations({ pattern, page }) {
	const params = {
		page_index: page,
		page_size: PAGE_SIZE,
		search_for: pattern,
	};

	const options = {
		method: "GET",
		params,
		url: `${API_URL}/api/applications/installation_queue`,
	};

	return axiosWithAuth(options);
}
